type PaymentPlanFrequency =
  | "weekly"
  | "bi_weekly"
  | "monthly"
  | "one_time"
  | "first_and_fifteenth"
  | "last_business_day_of_the_month"
  | "non_linear"
  | "tax_season";

type PaymentPlanType =
  | "HARDSHIP"
  | "HARDSHIP_EXTENSION"
  | "INTERIM"
  | "NORMAL"
  | "PAYOFF"
  | "REACTIVATED"
  | "TAX_SEASON"
  | "DOWN_PAYMENT";

type PaymentMethodTypes = "ach" | "card" | "check" | "unknown" | "other";

type PaymentPlanState = "current" | "late" | "revoked" | "active" | "resolved" | "no_plan" | "active_interim";

type PaymentStatus =
  | "Success"
  | "Approved"
  | "Submitted"
  | "Validation"
  | "Pending"
  | "Warning"
  | "Decline"
  | "Failed"
  | "Fraud"
  | "SystemFailure"
  | "Communication"
  | "Error"
  | "Void"
  | "Refund"
  | "Chargeback"
  | "Returned";

const successfulPaymentsStatuses: PaymentStatus[] = ["Success", "Submitted", "Approved"];
const warningPaymentStatuses: PaymentStatus[] = ["Pending"];
const failedPaymentsStatuses: PaymentStatus[] = [
  "Decline",
  "Failed",
  "Error",
  "Fraud",
  "SystemFailure",
  "Void",
  "Refund",
  "Chargeback",
  "Returned",
];

enum PlanRating {
  RED = "RED",
  YELLOW = "YELLOW",
  GREEN = "GREEN",
}

export type {PaymentPlanFrequency, PaymentMethodTypes, PaymentPlanState, PaymentStatus, PaymentPlanType};
export {successfulPaymentsStatuses, failedPaymentsStatuses, warningPaymentStatuses, PlanRating};
